import en from "../../language/Eng_Aust.json";

export const isMobileDevice = () => {
  const mobileUserAgent = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const iPadDesktopMode = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1;

  return mobileUserAgent || iPadDesktopMode;
};

export const openUberEats = () => {
  if (isMobileDevice()) {
    window.location.assign(en.home.links.uberEats);
    return;
  }

  window.open(en.home.links.uberEats, "_blank", "noopener,noreferrer");
};
